import {
    useBlockProps,
    InspectorControls,
    MediaUpload,
} from '@wordpress/block-editor';
import {
    PanelBody,
    TextControl,
    Button,
    TextareaControl,
    ToggleControl,
} from '@wordpress/components';
import {__} from '@wordpress/i18n';

export default function Edit({attributes, setAttributes}) {
    const {
        linkURL = {},
        mediaID,
        mediaURL,
        mediaCaption,
        headline,
        content,
        explanation,
    } = attributes;

    const blockProps = useBlockProps({className: 'bem-imagetextblock-save__row h-100'});

    const effectiveHeadline = headline?.trim() || content?.trim() || '';
    const effectiveLinkTitle = (linkURL?.title != linkURL.url && linkURL?.title != "View more") ? linkURL?.title : "View more";

    const onSelectImage = (media) => {
        setAttributes({
            mediaID: media.id,
            mediaURL: media.url,
            mediaCaption: media.caption || media.alt || '',
        });
    };

    const updateLink = (field, value) => {
        setAttributes({
            linkURL: {
                ...linkURL,
                [field]: value,
            },
        });
    };

    return (
        <>
            <InspectorControls>
                <PanelBody title={__('Settings')}>
                    <MediaUpload
                        onSelect={onSelectImage}
                        allowedTypes={['image']}
                        value={mediaID}
                        render={({open}) => (
                            <Button onClick={open} isPrimary>
                                {mediaURL ? __('Replace Image') : __('Upload Image')}
                            </Button>
                        )}
                    />
                    <TextControl
                        label={__('Image Caption')}
                        value={mediaCaption}
                        onChange={(val) => setAttributes({mediaCaption: val})}
                    />
                    <TextControl
                        label={__('Headline Title')}
                        value={headline}
                        onChange={(val) => setAttributes({headline: val})}
                    />
                    <TextareaControl
                        label={__('Explanation')}
                        value={explanation}
                        onChange={(val) => setAttributes({explanation: val})}
                    />
                    <TextControl
                        label={__('Link URL')}
                        value={linkURL?.url || ''}
                        onChange={(val) => updateLink('url', val)}
                    />
                    <TextControl
                        label={__('Link Title (leave Empty for default)')}
                        value={effectiveLinkTitle}
                        onChange={(val) => updateLink('title', val)}
                    />
                    <ToggleControl
                        label={__('Open in New Tab')}
                        checked={linkURL?.opensInNewTab || false}
                        onChange={(val) => updateLink('opensInNewTab', val)}
                    />
                </PanelBody>
            </InspectorControls>

            <div {...blockProps}>
                <div className="bem-imagetextblock-save__card card h-100">
                    {mediaURL && (
                        <img
                            src={mediaURL}
                            className="bem-imagetextblock-save__img card-img-top img-fluid rounded"
                            alt=""
                        />
                    )}

                    <div className="bem-imagetextblock-save__footer card-footer">
                        <small className="bem-imagetextblock-save__footersmall text-muted">
                            {mediaCaption}
                        </small>
                    </div>
                    <div className="bem-imagetextblock-save__cardbody card-body">
                        <div className="bem-imagetextblock-save__content">
                            <div className="bem-imagetextblock-save__headline">
                                {effectiveHeadline}
                            </div>
                            <div className="bem-imagetextblock-save__explanation">
                                {explanation}
                            </div>
                        </div>
                        <a className="bem-imagetextblock-save__viewmore"
                           href="#" rel="noopener">
                            {effectiveLinkTitle}
                        </a>
                    </div>
                </div>
            </div>
        </>
    )
        ;
}
